import { signal } from "@preact/signals-react"

export const isOpenProvidersSuppliersMappingModal = signal([])
export const selectedTable = signal(null)
export const isLoadingModal = signal(false)